// @flow
import styled, { keyframes } from 'styled-components';

import SVGIcon from '~/core/icons/svg-icons';

const POPUP_WIDTH = 12;
const RADIUS = 0.25;
export const SIZE = 2.2;

const reveal = keyframes`
    from { transform: scale3d(1, 0, 1) }
    to { transform: scale3d(1, 1, 1) }
`;

export const Base = styled.div`
    height: ${SIZE}em;
    outline: none;
    position: relative;
    width: ${SIZE}em;
    transition: background-color 0.2s ease-out;

    &:focus {
        background-color: ${p => (p.selected ? 'inherit' : p.theme.lightGrey)};
    }
`;

export const Icon = styled(SVGIcon)`
    height: ${SIZE}em;
    padding: ${SIZE * 0.2}em;
    width: ${SIZE}em;
`;

export const MainIcon = Icon.extend`
    border-radius: ${RADIUS}em ${RADIUS}em 0 0;
    box-shadow: ${p => (p.selected ? `0 0 0.5em 1px ${p.theme.secondaryHeavy}` : 'none')};
    cursor: pointer;

    & > g {
        fill: ${p => p.theme.secondaryHeavy};
    }
`;

export const Popup = styled.div`
    animation: ${reveal} 0.1s ease-out forwards;
    background-color: ${p => p.theme.white};
    border-radius: ${p => (p.left ? `${RADIUS}em 0 ${RADIUS}em ${RADIUS}em` : `0 ${RADIUS}em ${RADIUS}em ${RADIUS}em`)};
    box-shadow: 0 0 0.5em 1px ${p => p.theme.secondaryHeavy};
    overflow: hidden;
    position: absolute;
    right: ${p => (p.left ? '0' : 'inherit')};
    top: ${SIZE}em;
    width: ${POPUP_WIDTH}em;
    z-index: 1;
`;

export const ShadowMask = styled.div`
    background-color: ${p => p.theme.white};
    height: ${SIZE * 0.2}em;
    position: absolute;
    top: ${SIZE * 0.8}em;
    width: ${SIZE}em;
    z-index: 2;
`;

export const Item = styled.div`
    cursor: pointer;
    display: flex;
    height: ${SIZE}em;
    margin: 0.2em 0;

    &:hover > div {
        text-decoration: underline;
    }
`;

export const ItemIcon = Icon.extend`
    flex: 0 0 ${SIZE}em;

    & > g {
        fill: ${p => p.theme.fontColor};
    }
`;

export const ItemCaption = styled.div`
    align-items: center;
    display: flex;
    flex: 1 0 auto;
    justify-content: flex-start;
    padding-left: 0.5em;
`;

export const ItemCaptionContent = styled.div`
    text-decoration: ${p => (p.selected ? 'underline' : 'inherit')};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: ${POPUP_WIDTH - SIZE - 0.5}em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/context-menu/styles.js